import encoding from "encoding-japanese";

export default class SubShare {
    constructor() {
        this.init();
    }

    init() {
        const shareurl = {
            twitter: "https://twitter.com/intent/tweet?text=",
            line: "https://line.me/R/msg/text/?",
            facebook: "https://www.facebook.com/sharer/sharer.php?u=",
        };

        [...document.querySelectorAll(".js-page-share")].forEach(($share) => {
            const txt = encoding.urlEncode($share.getAttribute("data-share"));

            if ($share.classList.contains("-twitter")) {
                const link = shareurl.twitter + txt;
                $share.setAttribute("href", link);
            } else if ($share.classList.contains("-line")) {
                const link = shareurl.line + txt;
                $share.setAttribute("href", link);
            } else {
                const link = shareurl.facebook + txt;
                $share.setAttribute("href", link);
            }
        });
    }
}
